// @ts-nocheck
/**
 * window[ids] library is loaded in MenuIDS.aspx.cs
 */
if (window['idslib']) {
    const idslib = window['idslib'];
    console.debug('idsMenu > instance.easeOfUse', instance.easeOfUse)
    
    $(() => {
        idslib.menuInitialize();
    })
}